var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-arrow-left"}}),_vm._v(" 返回 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }